module.exports = __webpack_public_path__ + "img/pci-dark.9e2a8c5f.svg";